import { gql } from '@efficiently/client-core-graphql-models';

export const PROJECT_DESIGN_CHANGE = gql(`
	query ProjectDesignChange($_id: ID!) {
		projectDesignChange(_id: $_id) {
			...ProjectDesignChangeDetail
		}
	}
`);
